import { memo, useCallback, useMemo } from "react";
import { Pagination as PaginationAntd } from "antd";
import PropTypes from "prop-types";

const Pagination = ({
  current = 1,
  pageSize = 15,
  total = 0,
  onChange = () => {},
  onShowSizeChange = () => {},
  hideOnSinglePage = false,
  showSizeChanger = false,
  minPageSize = 15,
  pageSizeOptions = [15, 25, 50, 100],
  ...props
}) => {
  const onChangePageSize = useCallback(
    (current, size) => {
      if (typeof onShowSizeChange === "function") {
        onShowSizeChange(current, size);
      }
    },
    [onShowSizeChange]
  );

  const isOnlyOnePage = useMemo(() => {
    const totalPages = Math.ceil(total / pageSize);
    return totalPages <= 1;
  }, [total, pageSize]);

  return (
    <div className={isOnlyOnePage ? "pagination-hide-numbers" : ""}>
      <PaginationAntd
        pageSizeOptions={pageSizeOptions}
        onShowSizeChange={onChangePageSize}
        hideOnSinglePage={
          hideOnSinglePage
            ? hideOnSinglePage
            : total <= minPageSize
            ? true
            : false
        }
        current={current}
        pageSize={pageSize}
        total={total}
        onChange={onChange}
        showSizeChanger={showSizeChanger}
        {...props}
      />
    </div>
  );
};

Pagination.propTypes = {
  current: PropTypes.number,
  pageSize: PropTypes.number,
  total: PropTypes.number,
  onChange: PropTypes.func,
  onShowSizeChange: PropTypes.func,
  hideOnSinglePage: PropTypes.bool,
  showSizeChanger: PropTypes.bool,
  keyPerPage: PropTypes.string,
  minPageSize: PropTypes.number,
  pageSizeOptions: PropTypes.array,
};

export default memo(Pagination);
